module.exports = __webpack_public_path__ + "img/WLGHZX_3.6c69495c.jpg";